import type { Stock } from '@maestro/data-layer'

export function isPurchasable(stock?: Stock | null): boolean {
  return stock?.purchasable ?? true
}
